import { useGetItemsForWatchLaterPageQuery } from '../../../__generated__/chirp/com/hubspot/watch/later/bff/rpc/WatchLaterBFFChirpService.hooks';
import { useAddBookmarkMutation, useRemoveBookmarkMutation } from '../../../__generated__/chirp/com/hubspot/academy/learning/backlog/rpc/BookmarkRpc.hooks';
import { GET_ITEMS_FOR_WATCH_LATER_PAGE_QUERY } from '../../../__generated__/chirp/com/hubspot/watch/later/bff/rpc/WatchLaterBFFChirpService.dfc.new';
import { getQueryFieldName } from '../../utils/DataFetchingClientCache';
export const useWatchLater = variables => useGetItemsForWatchLaterPageQuery({
  variables
});
export const useAddToWatchLater = variables => useAddBookmarkMutation({
  variables,
  update: (cache, result) => {
    var _result$data;
    // refetch queries doesn't refetch the query unless it is watched
    if ((_result$data = result.data) !== null && _result$data !== void 0 && (_result$data = _result$data.result) !== null && _result$data !== void 0 && _result$data.success) {
      cache.evict({
        fieldName: getQueryFieldName(GET_ITEMS_FOR_WATCH_LATER_PAGE_QUERY)
      });
    }
  }
});
export const useRemoveFromWatchLater = variables => useRemoveBookmarkMutation({
  variables,
  update: (cache, result) => {
    var _result$data2;
    if ((_result$data2 = result.data) !== null && _result$data2 !== void 0 && (_result$data2 = _result$data2.result) !== null && _result$data2 !== void 0 && _result$data2.success) {
      cache.evict({
        fieldName: getQueryFieldName(GET_ITEMS_FOR_WATCH_LATER_PAGE_QUERY)
      });
    }
  }
});